export default __webpack_public_path__ + "static/media/CIA-Consent-Credit-Checks-November2025.fc6ddb36.pdf";